<!--
    Name:			BatchDetail.vue

    Description:	Show the batch in an overlay.
                    Used in for example the batch.vue

    Remarks:
-->

<template>
    <div :class="accentClass">
        <div class="orderinfo accent-background panel">

            <div class="panel">
                <h5><translate item="BatchDetail.Batch" />  {{ Batch.startTime | formatTime}} - {{ Batch.endTime | formatTime}} ({{Batch.totalTime / 60}} min)</h5>
            </div>

        </div>
        <div class="content-in">
            <div class="panel text-left">
                <div class="row">
                    <span class="col-3 text-left ">
                        <translate item="BatchDetail.Batch.Id" />:
                    </span>
                    <span class="col text-left">
                        {{Message}} {{Batch.id}}
                    </span>
                </div>

                <div class="row">
                    <span class="col-3  text-left">
                        <translate item="BatchDetail.Batch.Products" />:
                    </span>
                    <div class="col text-left ">
                        <div class="product" v-for="product in Batch.products" :title="product.name">
                            <div><!--{{product.quantity}}--> {{product.name}} {{product.preperation}}</div>
                        </div>
                    </div>
                </div>
                <br />
                <div class="row">
                    <span class="col-3 text-left">
                        <translate item="BatchDetail.Batch.Orders" />:
                    </span>
                    <div class="col text-left">
                        <div :key="order.id" v-for="order in Batch.orders" :title="order.name">
                            <div>{{order.orderNr}} - {{order.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br /><br />
        <div class="panel text-center">
            <div class="text-center">
                <div class="btn btn-dark" v-on:click="close"><translate item="BatchDetail.Batch.Close" /></div>
            </div>
        </div>
    </div>

</template>

<script>
    import Swal from "sweetalert2";
    import translate from '../components/translate'

    let options = {
        //weekday: "long", year: "numeric", month: "short",
        //day: "numeric",
        hour: "2-digit", minute: "2-digit"
    };

    const batchDetail = {

        components: { translate },
        props: {
            Batch: { type: Object },
            Message: { type: String }
        },

        created: function () {

            //alert('orderdetail');
        },

        methods: {
            getProductBeginTime: function (product) {
                return product.batches.reduce(function (a, b) { return a.startTime < b.startTime ? a : b; }).startTime.toLocaleTimeString("nl-nl", options);//  product.batches[0].startTime.toLocaleTimeString("nl-nl", options);
            },

            getProductEndTime: function (product) {
                return product.batches.reduce(function (a, b) { return a.endTime > b.endTime ? a : b; }).endTime.toLocaleTimeString("nl-nl", options);
            },

            close: function () {

                Swal.close();
            },




        },
        computed: {

            accentClass: function () {

                var className = {};
                className['accent' + this.Batch.status] = 1;
                return className;

            }
        }
    };

    export { batchDetail as default };

</script>
